export default __webpack_public_path__ + "static/media/tete62.4ba38171.png";